<ng-container [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <div class="loyalty-program-image-container mx-auto my-4 mt-0 flex">
      <img
        *ngIf="loyaltyProgramImageUrl()"
        class="loyalty-program-image"
        [src]="loyaltyProgramImageUrl()"
        alt="" />
    </div>
    <div class="transfer-terms flex-grow-1 flex flex-shrink-0 flex-col">
      <h2 class="loyalty-program-name mt-0 mb-6">{{ loyaltyProgram.name }}</h2>
      <div class="transfer-computation mt-auto flex-grow">
        <p class="loyalty-base-points mt-0 mb-2">
          {{
            'app.points_with_points_currency'
              | translate: tenantCurrencyPointsParams()
          }}
        </p>
        <rd-shared-icon
          [iconSymbol]="'icon-equal'"
          class="equal-icon mx-auto mb-2 flex h-4 w-4"></rd-shared-icon>
        <p class="loyalty-program-equivalent-points mt-0 mb-4">
          {{
            'app.points_with_points_currency'
              | translate: targetCurrencyPointsParams()
          }}
        </p>
      </div>
    </div>
    <rd-shared-button
      class="loyalty-program-link mx-auto flex"
      [buttonClass]="'loyalty-program-link'"
      [buttonContent]="buttonContent"
      [buttonTheme]="buttonTheme"
      [redirectURL]="checkoutUrl()"
      [ariaLabel]="
        'accessibility.transfer_v2.select'
          | translate
            : {
                item: loyaltyProgram.name,
                tenantPoints: tenantCurrencyPointsAmount(),
                tenantCurrency: tenantCurrency(),
                targetPoints: targetCurrencyPointsAmount(),
                targetCurrency: targetCurrency()
              }
      ">
      <ng-template #buttonContent>
        {{ 'transfer.programs.select' | translate }}
      </ng-template>
    </rd-shared-button>
  </ng-container>
  <ng-container *ngSwitchCase="'loading'">
    <div class="loading loading-loyalty-program-image mx-auto mb-5"></div>

    <div
      class="loading loading-loyalty-terms mx-auto flex flex-col items-center">
      <div class="loyalty-program-name mb-2 h-4 w-full"></div>
      <div class="loyalty-base-points mb-2 h-4 w-full"></div>
      <div class="points-transfer-icon mb-3 h-2 w-4"></div>
      <div class="loyalty-program-equivalent-points h-4 w-full"></div>
    </div>

    <div
      class="loading loading-loyalty-link button-height mx-auto w-full"></div>
  </ng-container>
</ng-container>
